<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 -2 10 10">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
</svg>
